import gql from "graphql-tag";

const SCRAPE_DSP_CAMPAIGNS = gql`
  query scrapeDSPCampaigns {
    scrapeDSPCampaigns
  }
`;

export default SCRAPE_DSP_CAMPAIGNS;
